import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// PrivateRoute avec gestion des rôles
const PrivateRoute = ({ allowedRoles, children }) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const location = useLocation();

  // Vérification si l'utilisateur est connecté
  if (!userInfo) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Vérification des rôles
  if (allowedRoles && !allowedRoles.includes(userInfo.role)) {
    // Si l'utilisateur n'a pas le rôle requis, redirection (par exemple, vers la page d'accueil)
    return <Navigate to="/" />;
  }

  // Si l'utilisateur est connecté et a le bon rôle, on affiche la route ou le composant enfant
  return children ? children : <Outlet />;
};

export default PrivateRoute;

